module.exports = __webpack_public_path__ + "media/images/up-43b8396d26a64ab61c494c822f23c663.png";